import "@flaticon/flaticon-uicons/css/all/all.css";

export default defineNuxtPlugin(() => {});
